<template>
  <div>
    <a-row>
      <a-col :span="20">
        <a-form layout="inline">
          <!-- <a-form-item label="实验类型">
            <a-select
              style="width: 100px"
              v-model:value="searchForm.type"
              :options="searchType"
              allowClear
            />
          </a-form-item> -->
          <a-form-item label="实验状态">
            <a-select
              style="width: 100px"
              v-model:value="searchForm.status"
              :options="statusOptionList"
              placeholder="ALL"
              allowClear
            />
          </a-form-item>
          <a-form-item label="实验ID">
            <a-input
              v-model:value="searchForm.id"
              placeholder="请输入"
            ></a-input>
          </a-form-item>
          <a-form-item label="实验名称">
            <a-input
              v-model:value="searchForm.name"
              placeholder="请输入"
            ></a-input>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="4">
        <a-space>
          <a-button type="primary" @click="searchFormData">查询</a-button>
          <a-button type="default" @click="resetFormData">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { defineComponent, inject, reactive, toRefs } from 'vue'
export default defineComponent({
  name: 'AddressRule',
  setup() {
    const state = reactive({})
    return {
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
})
</script>
